/* eslint-disable */
import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import "./yoda.css";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import { Skeleton, notification } from "antd";
import Carousel from "react-bootstrap/Carousel";
import { useSelector } from "react-redux";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { db } from "../../firebase";
import DashboardCardsDigital from "./dashboardComposants/DashboardCardsDigital";
import { motion, AnimatePresence } from "framer-motion"; // للحركات الاحترافية
import {
  Timestamp,
  collection,
  query,
  where,
  setDoc,
  doc,
  getDocs,
  arrayUnion,
} from "firebase/firestore";
import { useDispatch } from "react-redux";
import { fetchOrders } from "../../redux/orders/orders";
import CrispChat from "../../components/CrispChat";
import Dhd from "../../components/SystemDhd";
import UploadValidationModal from "../../components/ValidationDhd";
import DashboardCards from "./dashboardComposants/DashboardCards";
import BrowsersCard from "./dashboardComposants/BrowsersCard";
import BigChart from "./dashboardComposants/BigChart";
import AdsChart from "./dashboardComposants/socialMediaChart";
import MostDemandedProducts from "./dashboardComposants/MostDemandedProducts";
import DataTableTemplatingDemoDashboard from "../../components/orders/DataTableTemplatingDemo/DataTableTemplatingDemoDashboard";
import { createProductNotification } from "../../api/Notifications";
import Sawa9lyModal from "../sawa9ly/Sawa9lyModal";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";
import Modal from "react-modal";
import ActivationFoorCallRequest from "../../components/services/Activation/ActivationFoorCallRequest";
// import UAParser from "ua-parser-js";

function Dashboard() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const match = useMemo(() => {
    const match = location.pathname.match(/^\/sawa9ly\/(.+)$/);
    return match ? match[1] : null;
  }, [location.pathname]);

  const [orders, setOrders] = useState([]);
  const [showSideBar, setShowSideBar] = useState(true);
  const [isOfferExpired, setIsOfferExpired] = useState(false);
  const [selectedFoorCall, setSelectedFoorCall] = useState(false);
  const [showFoorCallPopup, setShowFoorCallPopup] = useState(true);
  const products = useSelector((state) => state.ProductsReducer);
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const user = useSelector((state) => state.userReducer.user);
  const auth = getAuth();
  const [api, contextHolder] = notification.useNotification();
  const UAParser = require("ua-parser-js");

  const handleOpenFoorCallModal = () => {
    setSelectedFoorCall(true);
    setShowFoorCallPopup(false);
  };

  const handleCloseFoorCallModal = () => {
    setSelectedFoorCall(false);
  };

  useEffect(() => {
    const setupOrdersListener = async (user, productMode) => {
      try {
        const nowDate = new Date();
        const startOfPreviousMonthDate = new Date(
          nowDate.getFullYear(),
          nowDate.getMonth() - 1,
          1,
          0,
          0,
          0,
          0,
        );

        const startOfPeriod = Timestamp.fromDate(startOfPreviousMonthDate);
        const now = Timestamp.fromDate(new Date());

        // Construction de la query de base
        let ordersQuery = [
          collection(db, "orders"),
          where("user", "==", user.uid),
          where("timeStamp", ">=", startOfPeriod),
          where("timeStamp", "<=", now),
        ];

        if (productMode === "digital") {
          ordersQuery.push(where("type", "==", "digitalProducts"));
        }

        const snapshot = await getDocs(query(...ordersQuery));
        const list = snapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter((order) => order.deleted !== 1)
          .sort((a, b) => b.timeStamp.seconds - a.timeStamp.seconds);

        const ordersWithIndex = list.map((item, index) => ({
          ...item,
          index: list.length - index + 999,
        }));

        setOrders(ordersWithIndex);

        // Synchroniser vers Redux
        dispatch(fetchOrders(ordersWithIndex));
      } catch (error) {
        console.log("Error fetching orders:", error);
      }
    };

    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (!user) return;

      await setupOrdersListener(user, account?.productMode);

      const q = query(collection(db, "account"), where("user", "==", user.uid));

      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const accountDoc = querySnapshot.docs[0];
        const accountData = accountDoc.data();

        const deviceData = await getDeviceData();
        const devices = accountData.devices || [];

        const deviceExists = devices.some(
          (device) => device.deviceName === deviceData.deviceName,
        );

        if (!deviceExists) {
          await setDoc(
            accountDoc.ref,
            {
              devices: arrayUnion(deviceData),
            },
            { merge: true },
          );
        }
      }
    });

    return () => {
      unsubscribeAuth();
    };
  }, [account?.productMode, dispatch]);

  // Check if DHD offer is expired
  useEffect(() => {
    const checkOfferExpiry = async () => {
      if (!user) {
        setIsOfferExpired(true);
        return;
      }

      try {
        const dhdQuery = query(
          collection(db, "dhd_form"),
          where("user", "==", user),
          where("acceptDHD", "==", true),
          where("pdfDownloaded", "==", true),
        );
        const snapshot = await getDocs(dhdQuery);

        if (!snapshot.empty) {
          setIsOfferExpired(true);
        }
      } catch (error) {
        console.error("Error checking DHD offer expiry:", error);
        setIsOfferExpired(false);
      }
    };

    checkOfferExpiry();
  }, [user]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getGeolocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => resolve(position),
          (error) => reject(error),
        );
      } else {
        reject("Geolocation is not supported by this browser.");
      }
    });
  };

  const getDeviceData = async () => {
    const userAgent = navigator.userAgent;

    const parser = new UAParser();
    const result = parser.getResult();

    let location = null;

    try {
      const position = await getGeolocation();
      location = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
    } catch (error) {
      console.error("Could not get location", error);
      location = { latitude: null, longitude: null };
    }

    return {
      deviceName: userAgent || "Unknown Device",
      deviceType: result.device.model || "Unknown Type",
      os: result.os.name || "Unknown OS",
      osVersion: result.os.version || "Unknown Version",
      location,
      isLoggedIn: true,
      timestamp: Timestamp.fromDate(new Date()),
    };
  };

  const [isOpen, setIsOpen] = useState(false);
  const [isValidationOpen, setIsValidationOpen] = useState(false);

  const handleToggle = (name) => {
    setSelectedCompanies((prev) =>
      prev.includes(name) ? prev.filter((c) => c !== name) : [...prev, name],
    );
  };

  return (
    <div className="container-fluid" dir={isRTL ? "rtl" : "ltr"}>
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 w-full mt-12 dark:!bg-[#141414]"
          style={{ flex: 1 }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
          {contextHolder}
          <CrispChat />
          {/* <div className="m-3 p-0 mt-16">

            {[
              "/videos/bannerSoon.mov",
              // "pcbanner3.jpg",
              // "pcbanner1.jpg",
              // "pcbanner2.jpg",
              // "pcbanner4.jpg",
            ].map((src, index) => (
              <video
                className="d-block w-100"
                src={src}
                alt={`Slide ${index}`}
                style={{ borderRadius: "12px" }}
              />
            ))}

          </div> */}
          {/* banner's section */}
          {(() => {
            const plan = account?.subscription?.plan || "";

            const planKey =
              plan === "شراكة مع dhd"
                ? "dhd"
                : plan === "الأسطورية"
                  ? "legendary"
                  : plan === "المتطورة"
                    ? "advanced"
                    : "basic";

            const basePath = `/videos/banner-${planKey}-plan`;

            return (
              <div className="m-3 mt-16 relative">
                <div
                  className="cursor-pointer overflow-hidden rounded-[20px]"
                  onClick={() => navigate("/special-offer")}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      navigate("/special-offer");
                    }
                  }}
                >
                  {/* for mobile */}
                  <video
                    key={`${planKey}-phone`}
                    className="block md:hidden w-full"
                    src={`${basePath}-phone.mp4`}
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="metadata"
                  />

                  {/* for pc */}
                  <video
                    key={`${planKey}-pc`}
                    className="hidden md:block w-full"
                    src={`${basePath}-pc.mp4`}
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="metadata"
                  />
                </div>
              </div>
            );
          })()}

          {(account?.productMode ?? "classic") === "classic" ? (
            <DashboardCards />
          ) : (
            <DashboardCardsDigital />
          )}

          <div className="w-full p-4">
            <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-5 gap-4">
              <BigChart />
              <BrowsersCard />
              <MostDemandedProducts products={products} />
              <AdsChart />
            </div>

            <div className="mt-4">
              {orders.length > 0 && (
                <DataTableTemplatingDemoDashboard
                  filter=""
                  orders={
                    (account.productMode ?? "classic") === "classic"
                      ? orders.filter((order) => order.deleveryStatus === "1")
                      : orders.filter(
                          (order) =>
                            order.status == 1 ||
                            order.status === 2 ||
                            order.status == 3,
                        )
                  }
                  pageSize={10}
                />
              )}
            </div>
          </div>
          <Footer />

          {/* FoorCall Popup */}
          {/* {showFoorCallPopup && !store?.foorCallRequestId && (
            <div className="fixed bottom-6 left-6 z-50 w-96 max-w-[calc(100vw-48px)] animate-bounce-in">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl transition-transform duration-300 hover:scale-[1.02]">

                <Link to="/foorcall" className="block w-full h-full cursor-pointer">
                  <img
                    src="/foorcall-service.png" // قم بتغيير هذا المسار إلى مسار الصورة الجديدة التي قمت بحفظها
                    alt="FoorCall Confirmation Service"
                    className="w-full h-auto block object-cover"
                  />
                </Link>

                <button
                  onClick={(e) => {
                    e.preventDefault(); // يمنع الانتقال للرابط عند الضغط على زر الغلق فقط
                    e.stopPropagation(); // يمنع انتشار الحدث للصورة بالأسفل
                    setShowFoorCallPopup(false);
                  }}
                  className="absolute top-4 right-4 text-white hover:text-gray-200 transition-all hover:scale-110 text-xl w-8 h-8 flex items-center justify-center rounded-full bg-black/30 hover:bg-black/50 font-bold z-10"
                  title="إغلاق"
                >
                  ×
                </button>

              </div>
            </div>
          )} */}

          {/* FoorCall Modal */}
          <Modal
            isOpen={selectedFoorCall}
            onRequestClose={handleCloseFoorCallModal}
            contentLabel="FoorCall Request"
            style={{
              overlay: {
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
                zIndex: 40,
              },
              content: {
                position: "absolute",
                top: "50%",
                left: "50%",
                right: "auto",
                bottom: "auto",
                marginRight: "-50%",
                transform: "translate(-50%, -50%)",
                maxWidth: "700px",
                width: "90%",
                maxHeight: "95vh",
                zIndex: 50,
                padding: 0,
                border: "none",
                borderRadius: "1.25rem",
                boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
              },
            }}
          >
            <div className="bg-white rounded-2xl max-h-[95vh] overflow-y-auto shadow-2xl border border-emerald-100">
              {/* Header with Logo */}
              <div className="relative bg-gradient-to-r from-emerald-500 to-teal-500 p-6 text-center border-b border-emerald-200">
                {/* Close Button */}
                <button
                  onClick={handleCloseFoorCallModal}
                  className="absolute top-4 right-4 text-white/80 hover:text-white transition-all hover:scale-110 text-2xl w-8 h-8 flex items-center justify-center"
                >
                  ×
                </button>

                {/* Logo */}
                <div
                  className="inline-flex items-center justify-center"
                  style={{
                    backgroundColor: "#ffffff",
                    padding: "8px",
                    borderRadius: "6px",
                    width: "64px",
                    height: "64px",
                  }}
                >
                  <img
                    src="/logo-min-2.png"
                    alt={t("ui.foorcallLogo")}
                    className="h-12 object-contain"
                  />
                </div>

                <h2 className="text-2xl font-bold text-white">
                  {i18n.language === "fr"
                    ? t("ui.foorcallService")
                    : i18n.language === "ar"
                      ? t("ui.foorcallService")
                      : t("ui.foorcallService")}
                </h2>
              </div>

              {/* Content */}
              <div className="p-8">
                <ActivationFoorCallRequest onClose={handleCloseFoorCallModal} />
              </div>
            </div>
          </Modal>

          {match && <Sawa9lyModal />}
          <Dhd isOpen={isOpen} setIsOpen={setIsOpen} />
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
